(function ($) {

    // var audio = $("#myAudio");
    // audio.play();

    // $('html').mousemove(function() {
    //     $('#myAudio')[0].play();
    // });

    //initialize tooltip
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // returntotop
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 200) { $('#return-to-top').show(200); }
        else { $('#return-to-top').hide(200); }
    });
    $('#return-to-top').click(function () {
        $('body,html').animate({ scrollTop: 0 }, 000);
    });

    // review-carousel
    $('.review-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots:true,
        // autoplay: true,
        navText: ['<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10H3.125" stroke="#3D081B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 4.375L3.125 10L8.75 15.625" stroke="#3D081B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#3D081B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#3D081B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        autoplayTimeout: 1000,
        autoplayHoverPause: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 2
            }
        }
    });

})(jQuery);

